import styled from '@emotion/styled';
import { space } from 'styled-system';
import { StyledProps } from './Header.types';
import { Theme } from './../Box.types';

export default styled.div<StyledProps, Theme>`
  ${space}
`;
